import { useDispatch } from 'react-redux';
import { ClientInput } from "../inputs/ClientInput";
import { setUnsupportedField } from "../../store/actions/client";
export const NonFunctionalPreviewField = ({
  guid,
  default: defaultValue,
  value,
  type,
  label,
  required,
  errors,
  parentGuid,
  rowGuid,
  disabled = false
}) => {
  const dispatch = useDispatch();
  const enableSmartPreviewInteraction = () => {
    const previewValue = value || defaultValue || '';
    dispatch(setUnsupportedField({
      type: type,
      guid: guid,
      parentGuid: parentGuid,
      rowGuid: rowGuid,
      value: previewValue
    }));
  };
  const getPlaceholderText = type => {
    const placeholder = {
      GPS: `Capture Location`
    };
    return placeholder[type] || `Capture ${type}`;
  };
  let fieldValue = `${value || getPlaceholderText(type)}`;
  return <ClientInput onClick={enableSmartPreviewInteraction} placeholder={' '} additionalClass={`tool-tip-event ${value && !errors ? 'completed' : 'incomplete'}`} value={fieldValue} label={required ? `${label}*` : label} error={!!errors.length} errorText={errors} disabled={disabled} />;
};